import { isEqual, isFunction } from "lodash";
import React, { createContext, useCallback, useContext } from "react";

const ClearingAccountReportUIContext = createContext();

export function useClearingAccountReportUIContext() {
  return useContext(ClearingAccountReportUIContext);
}

export const ClearingAccountReportUIConsumer =
  ClearingAccountReportUIContext.Consumer;

export function ClearingAccountReportUIProvider({
  clearingAccountReportUIEvents,
  children,
  queryParams,
  setQueryParamsBase,
  queryParamsChart,
  setqueryParamsChartBase
}) {
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const setqueryParamsChart = useCallback((nextQueryParams) => {
    setqueryParamsChartBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    queryParamsChart,
    setqueryParamsChartBase,
    setqueryParamsChart,
    openReceiptDialog: clearingAccountReportUIEvents.openReceiptDialog,
    handleExportButton: clearingAccountReportUIEvents.handleExportButton
  };

  return (
    <ClearingAccountReportUIContext.Provider value={value}>
      {children}
    </ClearingAccountReportUIContext.Provider>
  );
}
